import { Inject, Injectable } from '@angular/core';
import { Util } from '@libs/utilities/util';

import { IAddonFacebookSdkConfig } from '../facebook.interface';
import { AddonPageAddonsRenderer } from '../../../shared/page-addons-renderer.helper';
import { EnumAddonPageAddonInjection, IAddonAddOnScriptScript } from '../../../shared/page-addons.interface';


/**------------------------------------------------------
 * Facebook Chat
 * -------------
 * Angular Component
 * > https://medium.com/@fransandi/integrate-facebook-messenger-livechat-plugin-in-your-angular-application-a55bb355795a
 * > https://www.npmjs.com/package/ngx-facebook
 */
@Injectable()
export class AddonFacebookChatScript implements IAddonAddOnScriptScript {

	//** Configurations */
	private readonly GREETING_DEFAULT: string = `We will answer very soon.`;


	constructor(
		@Inject(EnumAddonPageAddonInjection.FacebookSocialConfig)
		private config			: IAddonFacebookSdkConfig,
		private rendererHelper	: AddonPageAddonsRenderer
	) {}


	create(): AddonFacebookChatScript {

		//0 - check if the facebook chat id was configured
		if (Util.String.isEmpty(this.config.pageId)) throw new Error(`AddonFacebookChatScript => create => FATAL ERROR: Facebook Page ID was not provided in the module (value is: "${this.config.pageId}")`);

		//1 - define the scripts
		// cspell:disable
		const scriptInnerHtml: string = `
			window.fbAsyncInit = function() {
				FB.init({
					xfbml   : true,
					version : 'v9.0'
				});
			};

			(function(d, s, id) {
				var js, fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) return;
				js = d.createElement(s); js.id = id;
				js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
				fjs.parentNode.insertBefore(js, fjs);
			}(document, 'script', 'facebook-jssdk'));
		`;
		// cspell:enable

		//2 - define the scripts attributes
		const divAttributes: IAddonDivAttributes = {
			attribution			: 'setup_tool',
			page_id				: this.config.pageId,
			logged_in_greeting	: this.config.customerChat?.greeting?.logged_in || this.GREETING_DEFAULT,
			logged_out_greeting	: this.config.customerChat?.greeting?.logged_in || this.GREETING_DEFAULT,
			class				: 'fb-customerchat'
		};

		//3 - add everything to the html
		this.rendererHelper.addScriptToHead('facebook_sdk', { innerHTML: scriptInnerHtml });
		this.rendererHelper.addDivElementToHtml('facebook_chat', { attributes: divAttributes });
		return this;
	}
}


//** Interfaces --------------------------------- */
interface IAddonDivAttributes {
	attribution			: string;
	page_id				: string;
	logged_in_greeting	: string;
	logged_out_greeting	: string;
	class				: string;
}
